module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/modal//egg.png?v=572b0eed";